import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import type { ExtractInjectionAPI, PMPluginFactoryParams } from '@atlaskit/editor-common/types';
import type { EditorState } from '@atlaskit/editor-prosemirror/state';
import { DecorationSet } from '@atlaskit/editor-prosemirror/view';

import type { AIDefinitionsPlugin, AIDefinitionsPluginConfig } from '../../types';
import { isLivePageViewMode } from '../../utils/api';

import { createPluginState, getPluginState } from './plugin-factory';
import { aiDefinitionsPluginKey } from './plugin-key';
import { getInitialState } from './state';

export const createPlugin = (
	{ dispatch }: PMPluginFactoryParams,
	{
		api,
		config,
	}: {
		// api is mandatory but can be undefined
		api: ExtractInjectionAPI<AIDefinitionsPlugin> | undefined;
		config: AIDefinitionsPluginConfig;
	},
) => {
	return new SafePlugin({
		key: aiDefinitionsPluginKey,

		state: createPluginState(dispatch, () => getInitialState()),

		/**
		 * if in the future we want to check whether the initial mode is view mode and initialize the decorations if it's view mode,
		 * we can call `onLivePageModeChange` in `view` to do this
		 */
		// view: {},

		props: {
			decorations(state: EditorState) {
				if (isLivePageViewMode({ api })) {
					const { keywordDecorations } = getPluginState(state);
					return keywordDecorations;
				} else {
					return DecorationSet.empty;
				}
			},

			handleDOMEvents: {},
		},
	});
};
